export const SHOW_HIDE_GALLERY = 'SHOW_HIDE_GALLERY'
export const SET_CURRENT_IMAGE = 'SET_CURRENT_IMAGE'
export const CHANGE_IMAGE_GALLERY = 'CHANGE_IMAGE_GALLERY'
